import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IWithdrawal } from '../interfaces/withdrawal/iwithdrawal';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WithdrawalService {
  url: string = `${environment.url}/withdrawals`;

  constructor(private http: HttpClient) { }

    save(req: IWithdrawal) {
        return this.http.post(
          `${this.url}`,
          req
        ) as Observable<IWithdrawal>;
    }
}
